import { createContext, useContext, useState, useCallback } from "react";

const AssessmentContext = createContext(null);

export const AssessmentProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const openAssessment = useCallback(() => setOpen(true), []);
  const closeAssessment = useCallback(() => setOpen(false), []);
  return (
    <AssessmentContext.Provider value={{ open, setOpen, openAssessment, closeAssessment }}>
      {children}
    </AssessmentContext.Provider>
  );
};

export const useAssessment = () => {
  const ctx = useContext(AssessmentContext);
  if (!ctx) throw new Error("useAssessment must be used within AssessmentProvider");
  return ctx;
};
